import { SplashScreen } from '@cigam/template/dist/components';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { logout, setUserData } from 'src/actions/accountActions';
import { runtimeConfigs } from 'src/config/runtimeConfigs';
import authService from 'src/services/authService';
import axios from 'src/utils/axios';

function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { hash } = qs.parse(useLocation().search, { ignoreQueryPrefix: true });

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout()),
      });

      const enviroment = await runtimeConfigs();

      if (enviroment) {
        axios.defaults.baseURL = `${enviroment.API_URL}/api`;
      }

      await authService.handleAuthentication(hash);

      if (authService.isAuthenticated()) {
        try {
          const user = await authService.loginInWithToken();
          const type = user.tipoLogin;

          dispatch(setUserData(user, type));
        } catch (error) {
          enqueueSnackbar(error, { variant: 'error' });
          authService.logout();
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch, enqueueSnackbar, hash]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.node,
};

export default Auth;
